import { gql } from '@apollo/client';

export const SUBJECTS_FOR_SELECT = gql`
  query subjects_for_select($where: subject_bool_exp) {
    subject(where: $where) {
      id
      name
      code
    }
  }
`;

export const INSERT_SUBJECT = gql`
  mutation insert_subject($objects: [subject_insert_input!]!) {
    insert_subject(objects: $objects) {
      affected_rows
    }
  }
`;

export const SUBJECT_LIST = gql`
  subscription subjectList($where: subject_bool_exp, $order_by: [subject_order_by!]) {
    subject(where: $where, order_by: $order_by) {
      id
      name
      code
      hoursPerSlot
      minutesPerSlot
      totalSlots
    }
  }
`;

export const SUBJECT = gql`
  query subject($where: subject_bool_exp) {
    subject(where: $where) {
      code
      color
      hoursPerSlot
      minutesPerSlot
      totalSlots
      id
      name
      subject_extra_slots {
        id
        name
        hoursPerSlot
        minutesPerSlot
        totalSlots
        totalMarks
      }
    }
  }
`;

export const UPDATE_NEW_SUBJECT = gql`
  mutation update_subject($where: subject_bool_exp!, $_set: subject_set_input) {
    update_subject(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const INSERT_SUBJECT_EXTRA_SLOT = gql`
  mutation insert_subject_extra_slot($objects: [subject_extra_slot_insert_input!]!) {
    insert_subject_extra_slot(objects: $objects) {
      affected_rows
    }
  }
`;

export const UPDATE_SUBJECT_EXTRA_SLOT = gql`
  mutation update_subject_extra_slot($where: subject_extra_slot_bool_exp!, $_set: subject_extra_slot_set_input) {
    update_subject_extra_slot(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const SUBJECTS_FOR_COURSE = gql`
  query subjectsForCourse {
    subject {
      id
      name
      code
      hoursPerSlot
      minutesPerSlot
      totalSlots
    }
  }
`;

export const DELETE_SUBJECT_EXTRA_SLOT = gql`
  mutation delete_subject_extra_slot($where: subject_extra_slot_bool_exp!) {
    delete_subject_extra_slot(where: $where) {
      affected_rows
    }
  }
`;

export const DELETE_SUBJECT = gql`
  mutation delete_subject($where: subject_bool_exp!) {
    delete_subject(where: $where) {
      affected_rows
    }
  }
`;

export const INSERT_SUBJECT_TO_USER = gql`
  mutation insert_subject_to_user($objects: [subject_to_user_insert_input!]!) {
    insert_subject_to_user(objects: $objects) {
      affected_rows
    }
  }
`;

export const UPDATE_SUBJECT_TO_USER = gql`
  mutation update_subject_to_user($_set: subject_to_user_set_input, $where: subject_to_user_bool_exp!) {
    update_subject_to_user(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const DELETE_SUBJECT_TO_USER = gql`
  mutation delete_subject_to_user($where: subject_to_user_bool_exp!) {
    delete_subject_to_user(where: $where) {
      affected_rows
    }
  }
`;

export const SUBJECTS_FOR_TIMETABLE = gql`
  query subjects_for_timetable(
    $batchSubjectWhere: batch_subject_configuration_bool_exp
    $userWhere: subject_to_user_bool_exp
  ) {
    batch_subject_configuration(where: $batchSubjectWhere) {
      id
      hoursPerSlot
      minutesPerSlot
      totalSlots
      subject {
        id
        name
        code
        color
        subject_to_users(where: $userWhere) {
          user {
            id
            employeeID
            firstName
            lastName
          }
        }
      }
      batch_subject_extra_slots {
        id
        name
        hoursPerSlot
        minutesPerSlot
        totalSlots
      }
    }
  }
`;

export const SUBJECTS_FOR_BATCH_SUBJECT_CONFIGURATION = gql`
  query subjects_for_batch_subject_configuration($where: subject_bool_exp) {
    subject(where: $where) {
      id
      hoursPerSlot
      minutesPerSlot
      totalSlots
      course_semester_subjects_subjects {
        courseSemesterId
        course_semester {
          courseId
        }
      }
      subject_extra_slots {
        id
        name
        hoursPerSlot
        minutesPerSlot
        totalSlots
        totalMarks
      }
    }
  }
`;
